import { IMDSTooltipProps, MDSTooltipPlacement } from "@/mds/components/tooltip/tooltip.types";
import { StyledTooltip } from "@/mds/components/tooltip/tooltip.style";
import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds/components/text";
import { TooltipTrigger } from "react-aria-components";
import { useFocusable } from "react-aria";
import { HTMLProps, useRef } from "react";
import { AnimationTiming } from "@/design-system/constants/common";

const DEFAULT_CLOSE_DELAY_MS = 0;

export const MDSTooltip = ({ config, children }: IMDSTooltipProps) => {
  if (!config) return children;
  const { label, shortcutLabel, placement = MDSTooltipPlacement.Top, delaySeconds } = config;
  const delayMs = delaySeconds
    ? delaySeconds * 1000
    : AnimationTiming.TooltipHoverDelaySeconds * 1000; // Default delay

  return (
    <TooltipTrigger delay={delayMs} closeDelay={DEFAULT_CLOSE_DELAY_MS}>
      {children}
      <StyledTooltip placement={placement}>
        <MDSText variant={MDSTextVariant.TextXs} color={MDSTextColor.OnAccent}>
          {label}
        </MDSText>
        {shortcutLabel && (
          <MDSText variant={MDSTextVariant.TextXs} color={MDSTextColor.Tertiary}>
            {shortcutLabel}
          </MDSText>
        )}
      </StyledTooltip>
    </TooltipTrigger>
  );
};

/**
 * For MDSTooltip to work on non-MDSButton or MDSIconButton components, we need to use this component to wrap the trigger.
 */
export const MDSTooltipTrigger = (props: HTMLProps<HTMLDivElement>) => {
  const ref = useRef<HTMLDivElement>(null);
  const focus = useFocusable(props, ref);
  return (
    <div ref={ref} tabIndex={0} {...focus.focusableProps}>
      {props.children}
    </div>
  );
};
